/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { DocumentIconOutline, FolderIconSolid } from '@neo4j-ndl/react/icons';
import { TreeView } from '@neo4j-ndl/react/next';
import { useState } from 'react';

/**
 * Folders here are pure containers: `isSelectable={false}` makes them expand on
 * click without ever becoming part of the selection, and screen readers
 * announce them as non-selectable rather than as unselected rows.
 */
const Component = () => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  return (
    <TreeView
      ariaLabel="File explorer"
      selectedIds={selectedIds}
      onSelectedIdsChange={setSelectedIds}
    >
      <TreeView.Item
        id="documents"
        title="Documents"
        hasChildren
        isSelectable={false}
        leadingVisual={<FolderIconSolid />}
      >
        <TreeView.Item
          id="work"
          title="Work"
          hasChildren
          isSelectable={false}
          leadingVisual={<FolderIconSolid />}
        >
          <TreeView.Item
            id="report"
            title="Report.pdf"
            leadingVisual={<DocumentIconOutline />}
          />
          <TreeView.Item
            id="presentation"
            title="Presentation.pptx"
            leadingVisual={<DocumentIconOutline />}
          />
        </TreeView.Item>
        <TreeView.Item
          id="resume"
          title="Resume.pdf"
          leadingVisual={<DocumentIconOutline />}
        />
      </TreeView.Item>
      <TreeView.Item
        id="images"
        title="Images"
        hasChildren
        isSelectable={false}
        leadingVisual={<FolderIconSolid />}
      >
        <TreeView.Item
          id="photo"
          title="Photo.jpg"
          leadingVisual={<DocumentIconOutline />}
        />
        <TreeView.Item
          id="screenshot"
          title="Screenshot.png"
          leadingVisual={<DocumentIconOutline />}
        />
      </TreeView.Item>
    </TreeView>
  );
};

export default Component;
